import React from "react";
import { Box } from "@mui/system";
import { ProjectsHighlights } from "../components/projectsHighlights/ProjectsHighlights";

export const Student: React.FC = () => {
  return (
    <Box sx={{ overflow: "hidden" }}>
      <ProjectsHighlights
        projectCategoryFilters={["STUDENT"]}
        disableProjectRandomization={true}
      />
    </Box>
  );
};
